// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconClickHandler_icon__28r_c"};